<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import StatChart from '@components/widget-stat-chart'
import Weather from '@/src/components/weather.vue'
import ViewerRegisterProspect from '@/src/components/register-prospect.vue'
import OverviewInformation from '@/src/services/overview_info'
import configuracaoService from '@/src/services/api-receituario/configuracao'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import empresaService from '@/src/services/empresa_sistema'
import weatherForecastService from '@/src/services/get-weather-forecasts'
moment.locale('pt-br')

/**
 * Dashboard-1 Component
 */
export default {
  components: {
    Layout,
    Loading,
    StatChart,
    apexchart: VueApexCharts,
    ViewerRegisterProspect,
    Weather,
  },
  data() {
    return {
      showTop: true,
      isLoading: false,
      total_pagar: 0,
      total_receber: 0,
      contas_vencidas: [],
      ultimas_receitas_emitidas: [],
      configuracao: '',
      empresa: {},
      weatherforecasts: [],
      statChart: [
        {
          mainTitle: 'Receitas Emitidas',
          value: 0,
          chartColor: '#5369f8',
        },
        {
          mainTitle: 'Receitas Canceladas',
          value: 0,
          chartColor: '#f77e53',
        },
        {
          mainTitle: 'Total Responsável Técnico',
          value: 0,
          chartColor: '#43d39e',
        },
        {
          mainTitle: 'Total Produtores',
          value: 0,
          chartColor: '#ffbe0b',
        },
      ],
      ultimasReceitasFields: [
        { key: 'data_emissao', label: 'Data de Emissão' },
        { key: 'numero_receita', label: 'Número da Receita' },
        { key: 'valor_nf', label: 'Valor' },
      ],
      contaVencidaField: [
        {
          key: 'descricao',
          label: 'Descrição',
          class: 'size-col-20',
        },
        {
          key: 'data_vencimento',
          label: 'Vencimento',
          class: 'size-col-20',
        },
        {
          key: 'valor_final',
          label: 'Valor',
          class: 'size-col-20',
        },
        {
          key: 'tipo_operacao',
          label: 'Tipo da Conta',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: { categories: [] },
      },
      series: [{ data: [], name: 'receitas' }],
    }
  },
  computed: {
    todayKey() {
      const today = new Date()
      const day = today
        .getDate()
        .toString()
        .padStart(2, '0')
      const month = (today.getMonth() + 1).toString().padStart(2, '0')
      const year = today.getFullYear()
      return `${day}/${month}/${year}`
    },
  },
  watch: {},
  mounted() {
    window.localStorage.setItem('configuracao', '')
    this.listandoInformações()
    this.handleGetConfiguracao()
    this.getEmpresa()

    let hubsPotScript = document.createElement('script')
    hubsPotScript.setAttribute(
      'src',
      'https://js-na1.hs-scripts.com/8761732.js'
    )
    document.head.appendChild(hubsPotScript)
  },
  methods: {
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
        this.getWeatherForecast()
      })
    },
    getWeatherForecast() {
      if (this.empresa != undefined && this.empresa.municipio != undefined) {
        let ibgeCode = this.empresa.municipio.ibge
        weatherForecastService.getWeatherForecast(ibgeCode).then((resposta) => {
          console.log(resposta.data[ibgeCode][this.todayKey])
          this.weatherforecasts = resposta.data[ibgeCode][this.todayKey]
        })
      }
    },

    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    listandoInformações() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      OverviewInformation.information(token)
        .then((response) => {
          console.log(response)
          this.statChart[0].value = response.data.receitas_emitidas
          this.statChart[1].value = response.data.receitas_canceladas
          this.statChart[2].value = response.data.total_agronomos
          this.statChart[3].value = response.data.total_produtores
          this.total_pagar = response.data.pagar
          this.total_receber = response.data.receber
          this.contas_vencidas = response.data.contas_vencidas
          this.ultimas_receitas_emitidas =
            response.data.ultimas_receitas_emitidas

          console.log(response.data.ultimas_receitas_emitidas)

          this.chartOptions = {
            xaxis: {
              categories: Object.keys(response.data.receitas_por_mes),
            },
          }
          this.series = [
            {
              data: Object.values(response.data.receitas_por_mes),
            },
          ]
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    handleGetConfiguracao() {
      const token = this.$store.state.auth.currentUser.token
      configuracaoService.listar(token).then((response) => {
        this.configuracao = response.data.configuracoes[0]
        window.localStorage.setItem(
          'configuracao',
          JSON.stringify(this.configuracao)
        )
      })
    },
    abrirReceitas() {
      this.$router.push({ path: '/register/receita' });
    },
    abrirFluxoCaixa() {
      this.$router.push({ path: '/financeiro/fluxo-de-caixa' });
    },
  },
}
</script>

<template>
  <Layout>
    <!-- <div
      @click="
        $bvModal.show('modal-prospect')
        showTop = false
      "
    >
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-bottom m-0 rounded-0"
        style="z-index: 2000; cursor: pointer"
        variant="success"
        dismissible
      >
        <span style="font-size: medium; font-weight: bold"
          >Ganhe R$ 100,00 a cada indicação, clique aqui e saiba mais.</span
        >
      </b-alert>
    </div> -->

    <div class="row page-title align-items-center"> </div>
    <div class="row">
      <div v-for="stat of statChart" :key="stat.mainTitle" class="col-md-6 col-xl-3 d-flex align-items-stretch">
        <div class="card stat-card flex-grow-1" :style="{ borderLeft: `4px solid ${stat.chartColor}` }">
          <div class="card-body p-2">
            <div class="media">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold d-block">
                  {{ stat.mainTitle }}
                </span>
                <h2 class="mb-0">{{ stat.value }}</h2>
              </div>
              <div class="align-self-center">
                <apexchart class="apex-chart-widget" type="area" height="35" width="70" :series="stat.series"
                  :options="stat.chartOptions"></apexchart>
                <span class="text-success font-weight-bold font-size-13"
                  :class="{ 'text-danger': `${stat.subValue}` === '5.05%' }">
                  {{ stat.subValue }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="card shadow-lg border-0 rounded-lg">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Receita por Mês</h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirReceitas">Ver Todos</button>
          </div>
          <div class="card-body p-4">
            <apexchart type="bar" height="300" :options="chartOptions" :series="series" class="apexchart-container">
            </apexchart>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card shadow-lg border-0 rounded-lg">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 v-if="weatherforecasts.manha || weatherforecasts.tarde || weatherforecasts.noite"
              class="mb-0 font-weight-bold">
              Previsão do tempo para {{ weatherforecasts.manha.entidade }} - {{ todayKey }}
            </h5>
            <h5 v-else class="mb-0 text-danger">Previsão do tempo</h5>
          </div>
          <div class="card-body p-4">
            <div v-if="weatherforecasts.manha || weatherforecasts.tarde || weatherforecasts.noite" class="row">
              <!-- Period Card -->
              <div
                v-for="(forecast, period) in { Manhã: weatherforecasts.manha, Tarde: weatherforecasts.tarde, Noite: weatherforecasts.noite }"
                v-if="forecast" :key="period" class="col-md-4 d-flex justify-content-center mb-4">
                <div class="weather-card p-4 rounded-lg shadow-sm bg-white text-center">
                  <h6 class="text-uppercase font-weight-bold mb-3">{{ period }}</h6>
                  <img v-if="forecast.icone" :src="forecast.icone" :alt="'Ícone do Tempo ' + period"
                    class="weather-icon mb-3" />
                  <p class="font-weight-bold mb-1">{{ forecast.resumo }}</p>
                  <p class="text-muted mb-1">
                    <i class="fas fa-temperature-high text-danger"></i> Máx: {{ forecast.temp_max }}°C
                  </p>
                  <p class="text-muted mb-1">
                    <i class="fas fa-temperature-low text-primary"></i> Mín: {{ forecast.temp_min }}°C
                  </p>
                  <p class="text-muted mb-0">
                    <i class="fas fa-wind"></i> Vento: {{ forecast.dir_vento }} - {{ forecast.int_vento }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="!weatherforecasts.manha && !weatherforecasts.tarde && !weatherforecasts.noite"
              class="text-center py-5">
              <p class="text-muted">Não foi possível obter informações da previsão do tempo.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row align-items-stretch">
      <!-- Resumo Financeiro -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Resumo Financeiro</h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirFluxoCaixa">Ver Todos</button>
          </div>
          <div class="card-body p-0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1 text-success font-weight-bold">Contas a Receber</h6>
                  <p class="mb-0 text-muted">
                    <i class="fas fa-calendar-alt"></i> Hoje
                  </p>
                </div>
                <span class="badge badge-pill badge-success">R$ {{ total_receber }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1 text-danger font-weight-bold">Contas a Pagar</h6>
                  <p class="mb-0 text-muted">
                    <i class="fas fa-calendar-alt"></i> Hoje
                  </p>
                </div>
                <span class="badge badge-pill badge-danger">R$ {{ total_pagar }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Contas Vencidas -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Contas Vencidas</h5>
          </div>
          <div class="card-body p-3">
            <b-table striped hover responsive="sm" borderless bordered outlined small :items="contas_vencidas"
              :fields="contaVencidaField" :per-page="perPage">
              <template v-slot:cell(data_vencimento)="row">
                {{
                  formatDate(row.item.data_vencimento) !== 'Invalid date'
                    ? formatDate(row.item.data_vencimento)
                    : row.item.data_vencimento
                }}
              </template>
            </b-table>
            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"
              class="mt-3"></b-pagination>
          </div>
        </div>
      </div>

      <!-- Últimas Receitas Emitidas -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Últimas Receitas Emitidas</h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirReceitas">Ver Todos</button>
          </div>
          <div class="card-body p-3">
            <b-table striped hover responsive="sm" borderless bordered outlined small :items="ultimas_receitas_emitidas"
              :fields="ultimasReceitasFields" :per-page="perPage">
              <template v-slot:cell(data_emissao)="row">
                {{ formatDate(row.item.data_emissao) }}
              </template>
              <template v-slot:cell(valor_nf)="row">
                R$ {{ row.item.valor_nf }}
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <ViewerRegisterProspect id="modal-prospect"></ViewerRegisterProspect> -->
    <loading :active.sync="isLoading" color="#008e75" :can-cancel="false"></loading>
  </Layout>
</template>
<style lang="scss">
/* Estilo principal do bloco */
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.5rem;
  /* Bordas mais suaves */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Sombra suavizada */
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  /* Interatividade */
}

.bloco:hover {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
}

/* Título principal do bloco */
.bloco .titulo {
  font-size: 24px;
  color: #008e75;
  margin-bottom: 15px;
  font-weight: bold;
  letter-spacing: 0.04rem;
}

/* Subtítulo */
.bloco .subtitulo {
  margin-bottom: 12px;
  color: #555;
  font-size: 18px;
  line-height: 1.5;
}

/* Divisória */
.bloco .borda {
  margin: 20px 0;
  border-bottom: solid 1px #edeff4;
}

/* Formulário centralizado */
.bloco .formulario {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

/* Botão principal */
.bloco .btn-webreceita {
  margin: 30px 0 10px;
  background-color: #008e75;
  padding: 10px 30px;
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  border: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.bloco .btn-webreceita:hover {
  background-color: #006f5a;
  transform: translateY(-2px);
}

.bloco .btn-webreceita.botaoTopo {
  float: right;
}

/* Botão de filtro */
.bloco .filterButton {
  margin: 30px 0 10px;
  background-color: #008e75;
  padding: 10px 30px;
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  border: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.bloco .filterButton:hover {
  background-color: #006f5a;
  transform: translateY(-2px);
}

/* Título do card */
.card-title {
  color: #007bff;
  font-weight: bold;
}

/* Ícone de temperatura mínima */
.temp-icon-min {
  transform: rotate(180deg);
}

/* Título do período */
.period-title {
  font-weight: bold;
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  text-transform: uppercase;
}

/* Gradiente no header */
.bg-gradient-light {
  background: linear-gradient(135deg, #f9f9f9, #e6e6e6);
  border-bottom: 1px solid #ddd;
  padding: 20px;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

/* Cartão do período do tempo */
.weather-card {
  background: linear-gradient(135deg, #ffffff, #f8f8f8);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 20px;
  border-radius: 10px;
}

.weather-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Ícone do tempo */
.weather-icon {
  max-width: 60px;
  height: auto;
  margin-bottom: 10px;
}

/* Card header */
.card-min-height {
  height: 250px;
  /* Altura fixa */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Distribui o conteúdo uniformemente */
  overflow: hidden;
  /* Evita overflow de conteúdo */
}

/* Ajustar o corpo do card */
.card-body {
  padding: 15px;
}

/* Ajustar o cabeçalho do card */
.card-header {
  padding: 10px 15px;
  min-height: 50px;
}

/* Estilização geral do card */
.card {
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 100px;
  /* Altura mínima reduzida */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Alinha conteúdo */
}

.card:hover {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
}

/* Texto descritivo */
.text-muted {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.4;
}

/* Tipografia geral */
h5 {
  font-size: 1.25rem;
  letter-spacing: 0.03rem;
  font-weight: bold;
}

h6 {
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  color: #333;
}

/* Ícones no weather card */
.weather-card i {
  margin-right: 5px;
  color: #555;
}

/* Suavidade em transições */
.card,
.weather-card,
.bloco .btn-webreceita,
.bloco .filterButton {
  transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
}

/* Responsividade geral */
@media (max-width: 768px) {
  .bloco {
    padding: 20px;
  }

  .bloco .titulo {
    font-size: 22px;
  }

  .bloco .subtitulo {
    font-size: 16px;
  }

  .btn-webreceita,
  .filterButton {
    padding: 8px 20px;
  }

  h5 {
    font-size: 1.1rem;
  }

  .card {
    min-height: 150px;
    /* Altura mínima menor em telas menores */
  }
}
</style>
